/**
 * RastreamentoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'

/* TODO: review generated class */
@HttpExclude()
export class RastreamentoCollection extends PageCollection<Rastreamento> {
  constructor() {
    super(Rastreamento)
  }

  queryAsPage() {
    return this.listRastreamento()
  }

  async listRastreamento() {
    return await Request.get(`/admin/rastreamento`, {params: this.params})
      .name('listRastreamento')
      .as(this)
      .getResponse()
  }

  async listCsvRastreamento() {
    return await Request.get(`/admin/rastreamento/csv`, {params: this.params})
      .name('listCsvRastreamento')
      .as(this)
      .getResponse()
  }
}
